import {Component,For,Show,Accessor, createSignal, onCleanup, createEffect, Match, Switch} from 'solid-js';
import {cleanImagePath} from './API';
import { Artwork, UserSession, SalonSummary } from './Types';
import { AddToCollectionModal } from './components/add-to-collection-modal';

type ArtworksGridProps = {
    session: UserSession;
    artworks: Accessor<Artwork[]>;
    imageBackgroundColor?: string;
}
export type SalonSummaryProps = {
    summary: SalonSummary;
}
export const SalonSummaryRender : Component<SalonSummaryProps> = ({ summary }) => 
<div style="border-top: 1px dotted #ccc; margin-top: 10px; padding-top: 10px;">
    <h3>
        <a href={`/Salon/Artwork/${summary.salonArtworkId}`}>{summary.name}</a>
    </h3>
    <ul style="margin-top: 10px;">
        <For each={(summary.results)}>{(award) =>
            <li>{award}</li>
        }</For> 
    </ul>
</div>;

export const ArtworksGrid : Component<ArtworksGridProps> = (props) => {
    const checkMobile = () => screen.width <= 768;
    const [isMobile, setIsMobile] = createSignal<boolean>(checkMobile());
    const width = () => isMobile() ? screen.width : 350;
    const updateIsMobile = () => setIsMobile(checkMobile());
    const [showModal, setShowModal] = createSignal<boolean>(false);
    const [selectedArtworkId, setSelectedArtworkId] = createSignal<string>("");
    const showAddToCollectionModal = (artwork: Artwork) => {
        setSelectedArtworkId(artwork.id.toString());
        setShowModal(true);
    }
    const closeAddToCollectionModal = () => {
        setSelectedArtworkId("");
        setShowModal(false);
    }
    createEffect(() => {
        window.addEventListener('resize', updateIsMobile);
    });
    onCleanup(async () => {
        window.removeEventListener('resize', updateIsMobile);
    });
return (
<div class="finalist-grid">
    <For each={props.artworks()}>{(artwork: Artwork) => {
        const mps = artwork.imageHeight && artwork.imageWidth ? (artwork.imageHeight * artwork.imageWidth) / 1000000 : 1;
        return (
        <div class="grid-item" style="display: inline-block; text-align: left; vertical-align: top;">
            <div>
                <Show when={artwork.imageCount}>
                    <div style={{ "position": "relative", "background-color": artwork.backgroundColor || props.imageBackgroundColor || "#333" }}>
                        <div>
                            <a href={ artwork.url}>
                                <Show when={artwork.imageHeight > 0 && artwork.imageWidth > 0}>
                                    <img class="artwork-image" alt={artwork.title}
                                        style={{ width: width() + "px", height: (artwork.imageHeight * (width() / artwork.imageWidth)) + "px" }}
                                        src={ cleanImagePath(artwork.primaryImageUrl) + "?format=jpg&mode=crop&width=" + width() } />
                                </Show>
                                <Show when={artwork.imageHeight === 0}>
                                    <img class="artwork-image"
                                        alt={artwork.title}
                                        src={ cleanImagePath(artwork.primaryImageUrl) + "?format=jpg&width=" + width() } />
                                </Show>
                            </a>
                            <Show when={artwork.imageCount > 1}>
                                <div class="inset">
                                    <a href={artwork.url} target="_blank">+ {artwork.imageCount - 1} more</a>
                                </div>
                            </Show>
                        </div>
                    </div>
                </Show>
                <Show when={artwork.isForSale}>
                    <div style="background-color: darkgoldenrod; padding: 10px 15px; font-family: 'Oswald'; font-size: 1.5em;">
                        <a href={ "/Artwork/Enquire?artworkId=" + artwork.id + "&campaign=ARCArtist" } style="color: #000;">Enquire about purchase <span class="fa fa-angle-double-right"></span></a>
                    </div>
                </Show>
                <Show when={artwork.isSold}>
                    <div style="background-color: #d2f7da; padding: 10px 15px; font-family: 'Oswald'; text-align: center; font-size: 1.5em;">
                        SOLD
                    </div>
                </Show>
                <div class="didactic">
                    <Show when={artwork.showHiresIcon}>
                        <span style="float: right;" class="hd">HD</span>
                    </Show>
                    <Show when={props.session.isLoggedIn}>
                        <div style="float: right; font-size: 1.5rem; color: goldenrod;">
                            <span class="fa fa-star" title="Add to your collections" onClick={(e) => { e.preventDefault(); showAddToCollectionModal(artwork) }}></span>
                        </div>
                    </Show>
                    <h1>
                        <a href={ artwork.url } target="_blank"><span innerHTML={artwork.title}></span></a>
                    </h1>
                    <Show when={!!artwork.alternateTitle}>
                        <h4 innerHTML={artwork.alternateTitle}></h4>
                    </Show>
                    <Show when={!!artwork.translateTitle}>
                        <h4 innerHTML={artwork.translateTitle}></h4>
                    </Show>
                    
                    <h3>
                        <a href={`/artists/${artwork.artist.slug}/${artwork.artist.id}`}>{artwork.artist.firstName} {artwork.artist.lastName}</a>
                    </h3>
                    <p class="date"><strong>{artwork.dateRange}</strong></p>
                    <p>{artwork.medium}</p>
                    <p innerHTML={artwork.measurements}></p>
                    <Show when={!!artwork.credit}>
                        <h4>Credit: <span innerHTML={artwork.credit}></span></h4>
                    </Show>
                    <Switch>
                        <Match when={mps < 1}>
                            <div>
                                less than 1 MP
                            </div>
                        </Match>
                        <Match when={mps == 1}>
                            <div>
                                1 MP
                            </div>
                        </Match>
                        <Match when={mps > 1}>
                            <div>
                                {Math.round(mps)} MPs
                            </div>
                        </Match>
                    </Switch>
                    <Show when={artwork.salonSummaries?.length}>
                        <SalonSummaryRender summary={artwork.salonSummaries[0]} />
                    </Show>
                </div>
            </div>
        </div>);
        }
    }</For>
    <Show when={showModal()}>
        <AddToCollectionModal
            artworkId={selectedArtworkId}
            showModal={showModal}
            onClose={closeAddToCollectionModal}
        />
    </Show>     
</div>);
}